import * as Sentry from '@sentry/browser'
import config from '@config/index'

const pattern = /^(.*).[0-9a-zA-Z]{32}.(.*)js$/

export const initialiseSentry = () => {
  Sentry.init({
    dsn: config.services.sentry.dsn,
    environment: config.application.stage,
    ignoreErrors: [
      'cancelled',
      'connection',
      'AbortError',
      'Network Error',
      'NetworkError',
      'Network error',
      'TypeError: cancelled',
      /^ECONNABORTED: timeout of 0ms exceeded$/,
      'Error: Network Error',
      'Failed to fetch',
    ],
    whitelistUrls: config.services.sentry.whitelistUrls,
    beforeSend: (event) => {
      if (event.exception && event.exception.values) {
        event.exception.values = event.exception.values.map((value) => {
          if (value.stacktrace) {
            // Here we convert the hashed script named back to the normalised name
            // as the artifacts are stored when the bundle is generated
            value.stacktrace.frames = value.stacktrace.frames.map((frame) => {
              if (pattern.test(frame.filename)) {
                const fileUriParts = frame.filename.split('/')
                const uriFilename = fileUriParts.pop()
                let filenameParts = uriFilename.split('.')
                filenameParts.splice(1, 1, 'hash')
                const filename = fileUriParts.join('/') + '/' + filenameParts.join('.')

                return {
                  ...frame,
                  filename,
                }
              }

              return frame
            })
          }

          return value
        })
      }

      // This is to ensure no errors (manually captured) are sent from blacklisted urls (includes local env)
      return config.services.sentry.whitelistUrls.some((pattern) => pattern.test(event.request.url)) ? event : null
    },
  })
}
